import md5 from 'md5'

const urlHelper = {
  install (Vue, options) {
    Vue.prototype.$urlHelper = this
  },
  byFlightNumber (flightNumber, date) {
    return getUrl({
      fnum: flightNumber,
      date: date
    })
  },
  byRoute (dep, arr, date, startHour = 0, endHour = 24) {
    return getUrl({
      dep: dep,
      arr: arr,
      date: date,
      starthour: startHour,
      endhour: endHour
    })
  },
  byAirport (airport, direction, page) {
    return getUrl({
      airport: airport,
      status: direction,
      page: page
    })
  },
  byDetail (params) {
    return getUrl(params)
  },
  getPreflight (params) {
    return getUrl(params, 'preflight')
  }
}

const getUrl = function (params, type = 'flight') {
  params.appid = 10695
  let key = '5cb447a97f3c3'
  params.lang = 'EN'
  let queryString = Object.keys(params).sort().filter(key => params[key]).map(key => key + '=' + params[key])
    .join('&')
  let token = md5(md5(queryString + key))
  if (type === 'flight') {
    return `/api/flight?${queryString}&token=${token}`
  } else if (type === 'preflight') {
    return `/api/preflight?${queryString}&token=${token}`
  }
}

export default urlHelper
